import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';
@Injectable({
  providedIn: 'root'
})
export class SettingsManagementService {

  constructor(
    private http: HttpClient,
  ) { }


  getGeneralSettings(): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.generalSettings.getGeneralSetting);
    return this.http.get<ApiResponse>(endpoint);
  }
  setGeneralSettings(payLoad: any): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.generalSettings.setGeneralSetting, null);
    return this.http.patch<ApiResponse>(endpoint, payLoad)
  }

}
